import { render, staticRenderFns } from "./DashboardPageTitle.vue?vue&type=template&id=5bafc1e8"
import script from "./DashboardPageTitle.vue?vue&type=script&lang=js"
export * from "./DashboardPageTitle.vue?vue&type=script&lang=js"
import style0 from "./DashboardPageTitle.vue?vue&type=style&index=0&id=5bafc1e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports